import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.parameterForm,
    rules: _ctx.rules,
    "label-position": "top",
    ref: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { lg: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "name",
                label: _ctx.$t('label.name')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.parameterForm.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parameterForm.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { lg: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "code",
                label: _ctx.$t('label.code')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.parameterForm.code,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parameterForm.code) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { lg: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "codFTP",
                label: _ctx.$t('label.codeFTP')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.parameterForm.codeFTP,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.parameterForm.codeFTP) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { lg: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "unit",
                label: _ctx.$t('label.units')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.parameterForm.unit,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.parameterForm.unit) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { lg: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "abbreviation",
                label: _ctx.$t('label.abbreviation')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.parameterForm.abbreviation,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.parameterForm.abbreviation) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { lg: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "client",
                label: _ctx.$t('label.parameterClient')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.parameterForm.client,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.parameterForm.client) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { lg: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                shadow: "never",
                class: "app-form-item"
              }, {
                header: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.instrumentationRange")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "min" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.instrumentationRange[0],
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.instrumentationRange[0]) = $event)),
                                min: 0
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "max" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.instrumentationRange[1],
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.instrumentationRange[1]) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                shadow: "never",
                class: "app-form-item"
              }, {
                header: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.physicalRange")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { lg: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "min" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.physicalRange[0],
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.physicalRange[0]) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { lg: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "max" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.physicalRange[1],
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.physicalRange[1]) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { lg: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "type",
                label: _ctx.$t('label.type')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.parameterForm.type,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.parameterForm.type) = $event)),
                    filterable: "",
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.initializeSubtype()))
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { lg: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "subtype",
                label: _ctx.$t('label.subtype')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.parameterForm.subtype,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.parameterForm.subtype) = $event)),
                    filterable: "",
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subtypeOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}